import { CLOUDFLARE_TURNSTILE_IS_ENABLED } from "@saleor/config";
import { ScgpUserStatus, useScgpUserLoginMutation } from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";

import { useUser } from "..";
import LoginPage from "../components/LoginPage";
import { LoginFormData } from "../components/LoginPage/types";
import {
  changePasswordPath,
  loginCallbackPath,
  // loginCallbackPath,
  LoginUrlQueryParams,
  // newPasswordPath,
  passwordResetUrl,
  updateEmailPath
} from "../urls";
import { setTokens } from "../utils";

export interface LoginViewProps {
  params: LoginUrlQueryParams;
}

const LoginView: React.FC<LoginViewProps> = ({ params }) => {
  const navigate = useNavigator();
  const [loadingLogin, setLoadingLogin] = useState<boolean>(false);
  const [error, setError] = useState(null);
  // const { location } = useRouter();
  const { loginByToken, authenticating } = useUser();
  const [scgpUserLogin] = useScgpUserLoginMutation({
    onCompleted: data => {
      setLoadingLogin(false);
      if (!data?.scgpUserLogin?.errors?.length) {
        if (data?.scgpUserLogin?.csrfToken && data?.scgpUserLogin?.token) {
          setTokens(
            data?.scgpUserLogin?.token,
            data?.scgpUserLogin?.csrfToken,
            data?.scgpUserLogin?.refreshToken,
            false
          );
          const params = new URLSearchParams(location.search);
          const redirectUrl = params.get("redirect");
          navigate(redirectUrl ? `/${redirectUrl}` : "/", { replace: true });
        }
        if (
          data?.scgpUserLogin?.status === ScgpUserStatus.FORCE_CHANGE_PASSWORD
        ) {
          navigate(
            `${changePasswordPath}?email=${data?.scgpUserLogin?.username}&token=${data?.scgpUserLogin?.tempToken}`,
            { replace: true }
          );
        }
        if (data?.scgpUserLogin?.status === ScgpUserStatus.FORCE_ADD_EMAIL) {
          navigate(
            `${updateEmailPath}?username=${data?.scgpUserLogin?.username}&token=${data?.scgpUserLogin?.tempToken}`,
            { replace: true }
          );
        }
        return;
      }
      setError(data?.scgpUserLogin?.errors?.[0]);
    }
  });

  const handleSubmit = async (data: LoginFormData) => {
    try {
      setLoadingLogin(true);
      scgpUserLogin({
        variables: {
          email: data?.email,
          password: data?.password,
          ...(CLOUDFLARE_TURNSTILE_IS_ENABLED && {
            cfTurnstileToken: data?.turnstileToken
          })
        }
      });
      // const user = await Auth.signIn(data.email, data.password);
      // if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
      //   sessionStorage.setItem("user", `${data.email},${data.password}`);
      //   navigate(newPasswordPath);
      // } else {
      //   Auth.currentSession().then(dataUser => handleLoginWithToken(dataUser));
      // }
    } catch (error) {
      setLoadingLogin(false);
      await loginByToken("");
    }
  };

  const handleLoginWithToken = async (sesstion, redirectUrl) => {
    const results = await loginByToken(sesstion.idToken.jwtToken);
    setTokens(results?.token, results?.csrfToken, results?.refreshToken, false);
    sessionStorage.removeItem("redirectUrl");
    location.replace(redirectUrl ? `/dashboard/${redirectUrl}` : "/dashboard/");
  };

  useEffect(() => {
    const { code, state } = params;
    const isCallbackPath = location.pathname.includes(loginCallbackPath);
    const redirectUrl = sessionStorage.getItem("redirectUrl");

    if (code && state && isCallbackPath) {
      setLoadingLogin(true);
      Auth.currentSession().then(sesstion =>
        handleLoginWithToken(sesstion, redirectUrl)
      );
    }
  }, []);

  return (
    <LoginPage
      error={error}
      disabled={authenticating}
      loading={authenticating || loadingLogin}
      onPasswordRecovery={() => navigate(passwordResetUrl)}
      onSubmit={handleSubmit}
    />
  );
};
LoginView.displayName = "LoginView";
export default LoginView;
